// Generated by scripts/write-cube-hell-replay-fixtures.ts.
// Do not edit manually.

import type { CubeHellReplayEventType } from "./event-adapter";

export interface CubeHellReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface CubeHellReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: CubeHellReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface CubeHellReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "cube-hell";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly CubeHellReplayFixturePlayer[];
  readonly events: readonly CubeHellReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const CUBE_HELL_REPLAY_FIXTURES: Record<string, CubeHellReplayFixture> =
  {
    "heuristic-2p": {
      schemaVersion: 1,
      gameType: "cube-hell",
      scenario: "heuristic-2p",
      source: "generated",
      capturedAt: "2026-06-27T00:00:00.000Z",
      players: [
        {
          id: "p1",
          name: "선 (휴리스틱·추리)",
          role: "host",
        },
        {
          id: "p2",
          name: "후 (휴리스틱·소극)",
          role: "player",
        },
      ],
      events: [
        {
          sequenceNumber: 1,
          eventType: "init",
          userId: "p1",
          payload: {
            state: {
              gameId: "heuristic-2p",
              players: [
                {
                  playerId: "p1",
                  label: "선",
                },
                {
                  playerId: "p2",
                  label: "후",
                },
              ],
              phase: "query",
              currentPlayerId: "p1",
              arrangements: {
                p1: [
                  "red",
                  "red",
                  "empty",
                  "yellow",
                  "green",
                  "green",
                  "empty",
                  "green",
                  "green",
                  "yellow",
                  "red",
                  "red",
                  "yellow",
                  "red",
                  "empty",
                  "yellow",
                  "green",
                  "empty",
                  "blue",
                  "blue",
                  "blue",
                  "yellow",
                  "blue",
                  "empty",
                  "empty",
                  "blue",
                  "empty",
                ],
                p2: [
                  "red",
                  "yellow",
                  "empty",
                  "red",
                  "red",
                  "empty",
                  "red",
                  "empty",
                  "empty",
                  "blue",
                  "yellow",
                  "yellow",
                  "blue",
                  "blue",
                  "green",
                  "red",
                  "green",
                  "green",
                  "empty",
                  "yellow",
                  "empty",
                  "blue",
                  "yellow",
                  "empty",
                  "blue",
                  "green",
                  "green",
                ],
              },
              log: [],
              queryCounts: {
                p1: 0,
                p2: 0,
              },
              rngState: 248188495,
              winnerId: null,
              lastAction: null,
              moveNumber: 0,
              guessPenalty: "immediate-loss",
              maxQueriesPerPlayer: null,
            },
          },
        },
        {
          sequenceNumber: 2,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 0,
            color: "red",
            moveNumber: 0,
          },
        },
        {
          sequenceNumber: 3,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 0,
            z: 0,
            moveNumber: 1,
          },
        },
        {
          sequenceNumber: 4,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 0,
            color: "yellow",
            moveNumber: 2,
          },
        },
        {
          sequenceNumber: 5,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 0,
            z: 0,
            moveNumber: 3,
          },
        },
        {
          sequenceNumber: 6,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 0,
            color: "green",
            moveNumber: 4,
          },
        },
        {
          sequenceNumber: 7,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 0,
            z: 0,
            moveNumber: 5,
          },
        },
        {
          sequenceNumber: 8,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 0,
            color: "blue",
            moveNumber: 6,
          },
        },
        {
          sequenceNumber: 9,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 1,
            z: 0,
            moveNumber: 7,
          },
        },
        {
          sequenceNumber: 10,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 1,
            color: "red",
            moveNumber: 8,
          },
        },
        {
          sequenceNumber: 11,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 1,
            z: 0,
            moveNumber: 9,
          },
        },
        {
          sequenceNumber: 12,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 1,
            color: "yellow",
            moveNumber: 10,
          },
        },
        {
          sequenceNumber: 13,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 1,
            z: 0,
            moveNumber: 11,
          },
        },
        {
          sequenceNumber: 14,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 1,
            color: "green",
            moveNumber: 12,
          },
        },
        {
          sequenceNumber: 15,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 2,
            z: 0,
            moveNumber: 13,
          },
        },
        {
          sequenceNumber: 16,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 1,
            color: "blue",
            moveNumber: 14,
          },
        },
        {
          sequenceNumber: 17,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 2,
            z: 0,
            moveNumber: 15,
          },
        },
        {
          sequenceNumber: 18,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 2,
            color: "red",
            moveNumber: 16,
          },
        },
        {
          sequenceNumber: 19,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 2,
            z: 0,
            moveNumber: 17,
          },
        },
        {
          sequenceNumber: 20,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 2,
            color: "yellow",
            moveNumber: 18,
          },
        },
        {
          sequenceNumber: 21,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 0,
            z: 1,
            moveNumber: 19,
          },
        },
        {
          sequenceNumber: 22,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 2,
            color: "green",
            moveNumber: 20,
          },
        },
        {
          sequenceNumber: 23,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 0,
            z: 1,
            moveNumber: 21,
          },
        },
        {
          sequenceNumber: 24,
          eventType: "QueryLayer",
          userId: "p1",
          payload: {
            playerId: "p1",
            axis: "z",
            index: 2,
            color: "blue",
            moveNumber: 22,
          },
        },
        {
          sequenceNumber: 25,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 0,
            z: 1,
            moveNumber: 23,
          },
        },
        {
          sequenceNumber: 26,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 0,
            z: 0,
            moveNumber: 24,
          },
        },
        {
          sequenceNumber: 27,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 1,
            z: 1,
            moveNumber: 25,
          },
        },
        {
          sequenceNumber: 28,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 0,
            z: 0,
            moveNumber: 26,
          },
        },
        {
          sequenceNumber: 29,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 1,
            z: 1,
            moveNumber: 27,
          },
        },
        {
          sequenceNumber: 30,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 0,
            z: 0,
            moveNumber: 28,
          },
        },
        {
          sequenceNumber: 31,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 1,
            z: 1,
            moveNumber: 29,
          },
        },
        {
          sequenceNumber: 32,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 1,
            z: 0,
            moveNumber: 30,
          },
        },
        {
          sequenceNumber: 33,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 2,
            z: 1,
            moveNumber: 31,
          },
        },
        {
          sequenceNumber: 34,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 1,
            z: 0,
            moveNumber: 32,
          },
        },
        {
          sequenceNumber: 35,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 2,
            z: 1,
            moveNumber: 33,
          },
        },
        {
          sequenceNumber: 36,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 1,
            z: 0,
            moveNumber: 34,
          },
        },
        {
          sequenceNumber: 37,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 2,
            z: 1,
            moveNumber: 35,
          },
        },
        {
          sequenceNumber: 38,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 2,
            z: 0,
            moveNumber: 36,
          },
        },
        {
          sequenceNumber: 39,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 0,
            z: 2,
            moveNumber: 37,
          },
        },
        {
          sequenceNumber: 40,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 0,
            z: 1,
            moveNumber: 38,
          },
        },
        {
          sequenceNumber: 41,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 0,
            z: 2,
            moveNumber: 39,
          },
        },
        {
          sequenceNumber: 42,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 0,
            z: 1,
            moveNumber: 40,
          },
        },
        {
          sequenceNumber: 43,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 0,
            z: 2,
            moveNumber: 41,
          },
        },
        {
          sequenceNumber: 44,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 0,
            z: 1,
            moveNumber: 42,
          },
        },
        {
          sequenceNumber: 45,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 1,
            z: 2,
            moveNumber: 43,
          },
        },
        {
          sequenceNumber: 46,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 1,
            z: 1,
            moveNumber: 44,
          },
        },
        {
          sequenceNumber: 47,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 1,
            z: 2,
            moveNumber: 45,
          },
        },
        {
          sequenceNumber: 48,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 1,
            z: 1,
            moveNumber: 46,
          },
        },
        {
          sequenceNumber: 49,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 1,
            z: 2,
            moveNumber: 47,
          },
        },
        {
          sequenceNumber: 50,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 1,
            z: 1,
            moveNumber: 48,
          },
        },
        {
          sequenceNumber: 51,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 2,
            z: 2,
            moveNumber: 49,
          },
        },
        {
          sequenceNumber: 52,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 2,
            z: 1,
            moveNumber: 50,
          },
        },
        {
          sequenceNumber: 53,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 2,
            z: 2,
            moveNumber: 51,
          },
        },
        {
          sequenceNumber: 54,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 2,
            z: 1,
            moveNumber: 52,
          },
        },
        {
          sequenceNumber: 55,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 2,
            z: 2,
            moveNumber: 53,
          },
        },
        {
          sequenceNumber: 56,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 2,
            z: 1,
            moveNumber: 54,
          },
        },
        {
          sequenceNumber: 57,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 0,
            z: 0,
            moveNumber: 55,
          },
        },
        {
          sequenceNumber: 58,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 0,
            z: 2,
            moveNumber: 56,
          },
        },
        {
          sequenceNumber: 59,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 0,
            z: 0,
            moveNumber: 57,
          },
        },
        {
          sequenceNumber: 60,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 0,
            z: 2,
            moveNumber: 58,
          },
        },
        {
          sequenceNumber: 61,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 0,
            z: 0,
            moveNumber: 59,
          },
        },
        {
          sequenceNumber: 62,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 0,
            z: 2,
            moveNumber: 60,
          },
        },
        {
          sequenceNumber: 63,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 1,
            z: 0,
            moveNumber: 61,
          },
        },
        {
          sequenceNumber: 64,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 1,
            z: 2,
            moveNumber: 62,
          },
        },
        {
          sequenceNumber: 65,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 1,
            z: 0,
            moveNumber: 63,
          },
        },
        {
          sequenceNumber: 66,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 1,
            z: 2,
            moveNumber: 64,
          },
        },
        {
          sequenceNumber: 67,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 1,
            z: 0,
            moveNumber: 65,
          },
        },
        {
          sequenceNumber: 68,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 1,
            z: 2,
            moveNumber: 66,
          },
        },
        {
          sequenceNumber: 69,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 2,
            z: 0,
            moveNumber: 67,
          },
        },
        {
          sequenceNumber: 70,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 0,
            y: 2,
            z: 2,
            moveNumber: 68,
          },
        },
        {
          sequenceNumber: 71,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 1,
            y: 2,
            z: 0,
            moveNumber: 69,
          },
        },
        {
          sequenceNumber: 72,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 1,
            y: 2,
            z: 2,
            moveNumber: 70,
          },
        },
        {
          sequenceNumber: 73,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 2,
            y: 2,
            z: 0,
            moveNumber: 71,
          },
        },
        {
          sequenceNumber: 74,
          eventType: "QueryCell",
          userId: "p1",
          payload: {
            playerId: "p1",
            x: 2,
            y: 2,
            z: 2,
            moveNumber: 72,
          },
        },
        {
          sequenceNumber: 75,
          eventType: "QueryCell",
          userId: "p2",
          payload: {
            playerId: "p2",
            x: 0,
            y: 0,
            z: 1,
            moveNumber: 73,
          },
        },
        {
          sequenceNumber: 76,
          eventType: "Guess",
          userId: "p1",
          payload: {
            playerId: "p1",
            arrangement: [
              "red",
              "yellow",
              "empty",
              "red",
              "red",
              "empty",
              "red",
              "empty",
              "empty",
              "blue",
              "yellow",
              "yellow",
              "blue",
              "blue",
              "green",
              "red",
              "green",
              "green",
              "empty",
              "yellow",
              "empty",
              "blue",
              "yellow",
              "empty",
              "blue",
              "green",
              "green",
            ],
            moveNumber: 74,
          },
        },
      ],
      notes: [
        "큐브지옥은 숨김정보 게임 — 양측 3×3×3 배열은 서버 권위. 픽스처 init은 양측 배열 전체(복기용)를 담고, 관전 화면은 상대 배열을 마스킹(?)한다.",
        "공정 추리(no-oracle): 봇은 공개 질문 로그만 사용(상대 배열 직접 조회 금지). p1=LAYER 12회로 층별 색 개수 파악 → 층별 색칸 다 찾으면 나머지는 빈칸으로 확정 → 완전배열 정답 선언. p2=소극(idle CELL 탐색, 추리 안 함).",
        "결과: 75수 (p1 LAYER 12 + CELL 25 + 추리 1) → 선(p1) 완전정답 승리.",
      ],
    },
  };
